module.exports = __webpack_public_path__ + "static/media/OPEN_ACADEMY2.11cda9af.jpg";